// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__ML35I","actions":"LoginForm_actions__n0UeL","message_between":"LoginForm_message_between__f9Hhg","forgottenPassword":"LoginForm_forgottenPassword__NFZcU"};